/**
 * Loading rows that match the reader's list geometry.
 */

interface ArticleSkeletonProps {
  count?: number;
}

export function ArticleSkeletonCard() {
  return (
    <div className="grid grid-cols-[3.5rem_1fr] lg:grid-cols-[4.5rem_1fr] border-b border-edge-subtle border-l-2 border-l-transparent">
      <div className="pl-2 lg:pl-3 pr-2 py-3 border-r border-edge-subtle">
        <div className="skeleton" style={{ width: '2.25rem', height: '0.75rem' }} />
      </div>
      <div className="pl-3 lg:pl-4 pr-4 py-2.5 max-w-list">
        <div className="skeleton mb-2" style={{ width: '9rem', height: '0.6875rem' }} />
        <div className="skeleton" style={{ width: '70%', height: '1.125rem' }} />
      </div>
    </div>
  );
}

export default function ArticleSkeleton({ count = 5 }: ArticleSkeletonProps) {
  return (
    <div>
      {Array.from({ length: count }).map((_, index) => (
        <ArticleSkeletonCard key={index} />
      ))}
    </div>
  );
}

export function SidebarItemSkeleton() {
  return (
    <div className="flex items-center gap-2 px-3 py-2">
      <div className="skeleton" style={{ width: '6px', height: '6px' }} />
      <div className="skeleton" style={{ width: '140px', height: '0.875rem' }} />
    </div>
  );
}

export function DigestCardSkeleton() {
  return (
    <div className="grid grid-cols-[3.5rem_1fr] lg:grid-cols-[4.5rem_1fr] border-b border-edge-subtle">
      <div className="pl-2 lg:pl-3 pr-2 py-3 border-r border-edge-subtle">
        <div className="skeleton" style={{ width: '2.25rem', height: '0.75rem' }} />
      </div>
      <div className="pl-3 lg:pl-4 pr-4 py-2.5 max-w-list">
        <div className="skeleton mb-2" style={{ width: '14rem', height: '0.6875rem' }} />
        <div className="skeleton mb-1" style={{ width: '100%', height: '1rem' }} />
        <div className="skeleton" style={{ width: '65%', height: '1rem' }} />
      </div>
    </div>
  );
}

export function SharedArticleSkeletonCard() {
  return (
    <div className="grid grid-cols-[3.5rem_1fr] lg:grid-cols-[4.5rem_1fr] border-b border-edge-subtle">
      <div className="pl-2 lg:pl-3 pr-2 py-3 border-r border-edge-subtle">
        <div className="skeleton" style={{ width: '24px', height: '24px', borderRadius: '50%' }} />
      </div>
      <div className="pl-3 lg:pl-4 pr-4 py-2.5 max-w-list">
        <div className="skeleton mb-2" style={{ width: '12rem', height: '0.6875rem' }} />
        <div className="skeleton mb-2" style={{ width: '70%', height: '1.125rem' }} />
        <div className="skeleton" style={{ width: '85%', height: '0.875rem' }} />
      </div>
    </div>
  );
}

export function SharedArticleSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div>
      {Array.from({ length: count }).map((_, index) => (
        <SharedArticleSkeletonCard key={index} />
      ))}
    </div>
  );
}
